import React, { useEffect, useState } from 'react';
export function CtaSection() {
  // Countdown: 8 hours, 19 min, 47 sec
  const [timeLeft, setTimeLeft] = useState(8 * 3600 + 19 * 60 + 47);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const days = Math.floor(timeLeft / 86400);
  const hours = Math.floor(timeLeft % 86400 / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section className="w-full bg-[#1a1f2e] px-4 md:px-8 pb-16" data-id="element-68">
      <style data-id="element-69">
        {`
          @keyframes pulseScale {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          .animate-pulse-scale {
            animation: pulseScale 1.5s ease-in-out infinite;
          }
        `}
      </style>

      <div className="max-w-[700px] mx-auto" data-id="element-70">
        {/* Flash Offer Card */}
        <div className="bg-[#232a3b] rounded-2xl p-8 text-center border border-[#333d52] mb-6" data-id="element-71">
          <p className="font-['Montserrat',_sans-serif] text-white font-extrabold text-lg md:text-xl uppercase mb-3" data-id="element-72">
            ⏰ Oferta Flash Limitada
          </p>
          <p className="font-['Montserrat',_sans-serif] text-[#ccc] text-sm md:text-base mb-6" data-id="element-73">
            El precio promocional y los 10 bonos de regalo expiran cuando el
            contador llegue a cero.
          </p>

          {/* Countdown */}
          <div className="flex justify-center gap-3 mb-6" data-id="element-74">
            {[{
            value: pad(days),
            label: 'DÍAS'
          }, {
            value: pad(hours),
            label: 'HORAS'
          }, {
            value: pad(minutes),
            label: 'MIN'
          }, {
            value: pad(seconds),
            label: 'SEG'
          }].map((item, i) => <div key={i} className="bg-[#1a1f2e] border border-[#4caf50] rounded-lg px-4 py-3 min-w-[65px]" data-id="element-75">
                <p className="font-['Montserrat',_sans-serif] text-white text-2xl md:text-3xl font-bold" data-id="element-76">
                  {item.value}
                </p>
                <p className="font-['Montserrat',_sans-serif] text-[#888] text-xs uppercase" data-id="element-77">
                  {item.label}
                </p>
              </div>)}
          </div>

          {/* Es tu momento badge */}
          <div className="inline-block bg-[#2d6a2e] rounded-full py-2.5 px-8" data-id="element-78">
            <p className="font-['Playfair_Display',_serif] text-white font-bold text-lg md:text-xl" data-id="element-79">
              ¡ES TU MOMENTO!
            </p>
          </div>
        </div>

        {/* CTA Button - pulsing */}
        <a href="https://cocinaydulcesrentables.com/cart/54079778619676:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#4caf50] hover:bg-[#43a047] text-white font-['Montserrat',_sans-serif] font-bold text-base md:text-lg uppercase py-4 md:py-5 rounded-full transition-colors shadow-[0_4px_16px_rgba(76,175,80,0.4)] mb-6 animate-pulse-scale text-center" data-id="element-80">
          ¡QUIERO ACCEDER AL SISTEMA COMPLETO YA!
        </a>

        {/* 569 personas badge - pulsing */}
        <div className="flex justify-center mb-5" data-id="element-81">
          <div className="bg-[#333d52] rounded-full py-3 px-6 animate-pulse-scale" data-id="element-82">
            <p className="font-['Montserrat',_sans-serif] text-white font-bold text-sm md:text-base" data-id="element-83">
              🔥 569 personas están aprovechando esta oportunidad.
            </p>
          </div>
        </div>

        {/* Price warning */}
        <p className="font-['Montserrat',_sans-serif] text-[#facc15] font-bold text-base md:text-lg text-center uppercase mb-5" data-id="element-84">
          <span className="inline-block animate-bounce" data-id="element-85">🔥</span>{' '}
          <span className="animate-pulse-scale inline-block" data-id="element-86">
            El precio aumentará en breve
          </span>
        </p>

        {/* Últimos cupos - pulsing */}
        <a href="https://cocinaydulcesrentables.com/cart/54079778619676:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#e74c3c] hover:bg-[#c0392b] text-white font-['Montserrat',_sans-serif] font-bold text-base md:text-lg uppercase py-4 md:py-5 rounded-full transition-colors shadow-[0_4px_16px_rgba(231,76,60,0.4)] mb-8 animate-pulse-scale text-center" data-id="element-87">
          ❗ ÚLTIMOS 3 CUPOS CON PRECIO CONGELADO
        </a>

        {/* Payment methods */}
        <div className="flex justify-center mb-6" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/2SBRG1SWUt1Bfe66mBS484/Captura_de_pantalla_2026-04-30_a_las_9.04.43_p._m..png" alt="Pago seguro garantizado - Visa, Mastercard, Maestro, Mercado Pago" className="max-w-[400px] w-full h-auto rounded-xl" data-id="element-89" />
        </div>

        {/* MercadoLider badge */}
        <div className="flex justify-center" data-id="element-90">
          <img src="https://cdn.magicpatterns.com/uploads/1XMJUMd4s9ViDsoYjjaH6m/Captura_de_pantalla_2026-04-30_a_las_9.04.51_p._m..png" alt="MercadoLíder Platinum - 145121 ventas" className="max-w-[400px] w-full h-auto rounded-xl" data-id="element-91" />
        </div>
      </div>
    </section>;
}